<template>
  <div class="search-container flex-container">
    <div class="flex-item">
      <div class="search-box flex-container">
        <span class="icon"><i></i></span>
        <input class="search-input flex-item" type="text" ref="inputRef" :placeholder="placeholder" v-model="inputValue">
        <!-- <span class="search-input flex-item" @click="search()">{{ inputValue }}</span> -->
      </div>
    </div>
    <span class="text" @click="search()">搜索</span>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        placeholder: '请输入任务名称',
        // inputValue: ''
        inputValue: this.value
      }
    },
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    watch: {
      value(newValue, oldValue) {
        this.inputValue = newValue
      }
    },
    methods: {
      search() {
        this.$emit('searchTask', this.inputValue)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .search-container {
    background: #0B5BDE;
    padding: 0 15px 10px;
    color: #fff;
    .search-box {
      height: 32px;
      border-radius: 22px;
      background: #377AE4;
      .icon {
        padding: 0 10px;
        margin: 6px 0;
        border-right: 1px solid #6397EA;
        i {
          display: inline-block;
          // padding: 0 10px;
          width: 16px;
          height: 18px;
          @include bg-image('~@/common/images/icon_search');
          background-size: 16px 18px;
        }
      }
      input {
        border: none;
        background: transparent;
        margin-left: 6px;
        outline: transparent;
        color: #fff;
        &::placeholder {
          color: #6397EA;
        }
      }
    }
    .text {
      margin-left: 10px;
      line-height: 32px;
      font-size: 14px;
    }
  }
</style>